import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";
import AWS from "aws-sdk";
import { Auth, API } from "aws-amplify";
import awsmobile from "../aws-exports.js";
import React, { useState, useEffect } from 'react';
import { tokenManager } from '../utils/tokenUtils';

// Create new application GraphQL API
export async function createApplication(app) {
  let user = await Auth.currentAuthenticatedUser();
  app.last_modified_by = user.username;
  // console.log(app);
  try {
    await tokenManager.makeAuthenticatedRequest(async (token) => {
      return await API.graphql({
        authMode: "AWS_LAMBDA",
        authToken: `Bearer ${token}`,
        query: mutations.createApplication,
        variables: { input: app },
      });
    });
  } catch (e) {
    console.log(e);
  }
}

// List all the applications graphQL API
export async function listApplications() {
  let filter = { deleted: { "ne": 1 } };
  let allApplications = [];
  let nextToken = null;

  try {
    do {
      const response = await tokenManager.makeAuthenticatedRequest(async (token) => {
        return await API.graphql({
          authMode: "AWS_LAMBDA",
          authToken: `Bearer ${token}`,
          query: queries.listApplications,
          variables: { filter: filter, nextToken: nextToken },
        });
      });

      // Append the current batch of applications to the result list
      allApplications = allApplications.concat(response.data.listApplications.items);

      // Update nextToken for the next iteration
      nextToken = response.data.listApplications.nextToken;
      // console.log('fetched applist count with token: '+allApplications.length);
    } while (nextToken); // Continue fetching until nextToken is null
  } catch (e) {
    console.log(e);
  }

  // Sort the applications by updated date in descending order(latest first)
  allApplications.sort((a, b) => {
    return new Date(b.updatedAt) - new Date(a.updatedAt);
  });

  // console.log('Total DR plans fetched with sorting:'+allApplications.length);
  // console.log(allApplications);

  // Return data in the same structure as before
  return {
    data: {
      listApplications: {
        items: allApplications
      },
    },
  };
}

// Get an application By Id GraphQL API
export async function getApplication(id) {
  try {
    return await tokenManager.makeAuthenticatedRequest(async (token) => {
      return await API.graphql({
        authMode: "AWS_LAMBDA",
        authToken: `Bearer ${token}`,
        query: queries.getApplication,
        variables: { id },
      });
    });
  } catch (e) {
    console.log(e);
  }
}

// Update an application by Id GraphQL API
export async function updateApplication(app) {
  let user = await Auth.currentAuthenticatedUser();
  app.last_modified_by = user.username;
  // console.log(app);
  try {
    await tokenManager.makeAuthenticatedRequest(async (token) => {
      return await API.graphql({
        authMode: "AWS_LAMBDA",
        authToken: `Bearer ${token}`,
        query: mutations.updateApplication,
        variables: { input: app },
      });
    });
  } catch (e) {
    console.log(e);
  }
}

// Delete an application by Id GraphQL API
export async function deleteApplication(id) {
  let user = await Auth.currentAuthenticatedUser();
  id.last_modified_by = user.username;
  id.deleted = 1;
  try {
    await tokenManager.makeAuthenticatedRequest(async (token) => {
      return await API.graphql({
        authMode: "AWS_LAMBDA",
        authToken: `Bearer ${token}`,
        query: mutations.updateApplication,
        variables: { input: id },
      });
    });
  } catch (e) {
    console.log(e);
  }
}

// Send a message to the FIFO dr queue
export async function recover(id, name, entity, plan, action) {
  var credentials = await Auth.currentCredentials();
  AWS.config.update({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: awsmobile.aws_project_region,
  });

  var env = getBackendEnvName();
  var sqs = new AWS.SQS({ apiVersion: "2012-11-05" });
  var qName = `drf-SQSTriggerLambda-SFN-${env}.fifo`;
  var queueUrl = await sqs.getQueueUrl({ QueueName: qName }).promise();
  // console.log(qName);
  // console.log("dr triggered..");
  var params = {
    MessageBody: JSON.stringify({ id, name, entity, plan, action }),
    QueueUrl: queueUrl.QueueUrl,
    MessageDeduplicationId: id,
    MessageGroupId: id,
  };

  sqs.sendMessage(params, function (err, data) {
    if (err) {
      // console.log("Error", err);
    } else {
      // console.log("Success", data.MessageId);
      alert(`Recovering: ${data.MessageId}`);
    }
  });
}

export async function getProducts() {
  const apiName = "GetProductsRestAPI";
  const path = "/products";
  const myInit = {};
  // get
  const products = await API.get(apiName, path, myInit);
  return products;
}
//hack to get env name from frontend
function getBackendEnvName() {
  const restEndpoint = awsmobile.aws_cloud_logic_custom[0].endpoint;
  return restEndpoint.split("amazonaws.com/")[1];
}

export async function getMPIVersion() {
  var credentials = await Auth.currentCredentials();
  AWS.config.update({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: awsmobile.aws_project_region,
  });
  var env = getBackendEnvName();
  let stack_prefix = `amplify-awsdisasterrecoverya-${env}`;
  // console.log('aa')
  // console.log(stack_prefix);
  try {
    const cloudFormation = new AWS.CloudFormation();
    // List stacks with the project name in their name
    let allStacks = [];
    async function fetchStacks(nextToken) {
      const params = nextToken ? { NextToken: nextToken } : {};
      const { StackSummaries, NextToken } = await cloudFormation.listStacks(params).promise();
      allStacks.push(...StackSummaries);
      if (NextToken) {
        await fetchStacks(NextToken);
      }
    }
    await fetchStacks();
    const stacks = allStacks.filter(stack => stack.StackName.includes(stack_prefix));
    let stack = stacks[0] // get any stack. it will have the tags
    // console.log(allStacks);
    // console.log(stacks)
    // stacks.forEach(stack => console.log(stack.StackName));
    // console.log(stack)
    if (!stack) {
      // console.log('Stack not found.');
      return "no_stack_found";
    }
    // Get the stack description
    const { Stacks } = await cloudFormation.describeStacks({ StackName: stack.StackName }).promise();
    const stackDescription = Stacks[0];

    // Check if the stack has tags
    if (!stackDescription.Tags || stackDescription.Tags.length === 0) {
      // console.log('Stack does not have any tags.');
      return "no_tags_found";
    }

    // Find the mpiversion tag
    const mpiversionTag = stackDescription.Tags.find(tag => tag.Key === 'mpiversion');

    if (mpiversionTag) {
      // console.log('mpiversion:', mpiversionTag.Value);
      return mpiversionTag.Value;
    } else {
      // console.log('mpiversion tag not found for the stack.');
      return "no_mpi_version_tag";
    }

    // return stacks;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

// export function AboutInfo({isAdmin, isOperator, adminGroup, operatorGroup, email, entity}) {
//   const [data, setData] = useState(null);
//   const [mpiVersion, setMPIVersion] = useState(null);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const version = await getMPIVersion();
//         setMPIVersion(version);
//       } catch (error) {
//         console.error('Error fetching MPI version:', error);
//       }
//     }
//     fetchData();
//   }, []);

//   return (
//     <div>
//       <div>
//         Role: {isAdmin ? adminGroup : ""}{isAdmin && isOperator ? " " : ""}
//         {isOperator ? operatorGroup : ""}
//       </div>
//       <div>User: {email} </div>
//       <div>Entity: {entity}</div>
//       <div>Version: 0.1.3</div>
//       {/* Check if data is still loading */}
//       {mpiVersion === null ? (
//         <div>MPI Version: Loading...</div>
//       ) : (
//         <div>MPI Version: {mpiVersion}</div>
//       )}
//     </div>
//   );
// }

export async function getlogurl(id) {
  var credentials = await Auth.currentCredentials();
  AWS.config.update({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: awsmobile.aws_project_region,
  });
  // console.log('lOGIN')
  try {
    const lambda = new AWS.Lambda();
    var env = getBackendEnvName();
    
    let params = {
      FunctionName   : `awsdisasterrecoveryaLambda-GenerateLogUrl-${env}`,               /* string type, required */                           /* 'STRING_VALUE' */
      InvocationType : 'RequestResponse',                /* string type: 'Event' (async)| 'RequestResponse' (sync) | 'DryRun' (validate parameters y permissions) */
      LogType        : 'None',                           /* string type: 'None' | 'Tail' */
      Payload: JSON.stringify({
        'id': id, 
      }),    
    };

    var lambdaResult = await lambda.invoke(params).promise();
    var lambdaResult = JSON.parse(lambdaResult.Payload);

    if (typeof lambdaResult === 'string' && lambdaResult === 'error') {

      var errorMessage = "No log has been found for this plan"

      // Create a modal dialog
      const modal = document.createElement('div');
      modal.classList.add('log-modal');

      // Create the modal content
      const modalContent = document.createElement('div');
      modalContent.classList.add('log-modal-content');

      // Create the error message
      const errorMessageElement = document.createElement('p');
      errorMessageElement.textContent = errorMessage;

      // Create the close button
      const closeButton = document.createElement('span');
      closeButton.classList.add('log-modal-close-button');
      closeButton.innerHTML = '&times;';

      // Add event listener to close the modal when the close button is clicked
      closeButton.addEventListener('click', () => {
        modal.remove();
      });

      // Append the close button to the modal content
      modalContent.appendChild(closeButton);

      // Append the error message to the modal content
      modalContent.appendChild(errorMessageElement);

      // Append the modal content to the modal
      modal.appendChild(modalContent);

      // Append the modal to the document body
      document.body.appendChild(modal);

    } else {
      // Open the URL with the result
      window.open(lambdaResult, '_blank', 'noopener,noreferrer');
    }


    // console.log(lambdaResult);

    // return stacks;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

